import { AuthContext, AuthUserDto } from '@therame/shared';
import { ref } from 'vue';

export function useAuthContext() {
  const authContext = ref<AuthContext>();

  const updateAuthContext = (user: AuthUserDto) => {
    AuthContext.overrideUser(authContext.value!, user);
  };

  return {
    updateAuthContext,
    authContext,
  };
}
